]<template>
	<div>
		<p>
			{{ selectRandom(["The primary ", "The study primary ", "In this study,"]) }}
			{{
				$tera.project.TrialWizard.primary &&
				$tera.project.TrialWizard.primary.length > 1
					? "outcomes will be"
					: "outcome will be"
			}}
			{{ joinArrayWithOr(mapArray($tera.project.TrialWizard.primary, "name")) }}
			{{ selectRandom([" assessed by ", " analysed by "]) }}
			{{
				joinArrayWithOr(mapArray($tera.project.TrialWizard.primary, "assessed"))
			}}
			{{
				selectRandom([
					"at the following time points: ",
					"at the following points: ",
					"at the following time points in the trial: ",
					"at the following periods in the trial: "
				])
			}}
			{{ joinArrayWithAnd(mapArray($tera.project.TrialWizard.primary, "time")) }}.
		</p>
		<p>
			{{ selectRandom(["The secondary ", "The study secondary "]) }}
			{{
				$tera.project.TrialWizard.secondary &&
				$tera.project.TrialWizard.secondary.length > 1
					? "outcomes will be"
					: "outcome will be"
			}}
			{{ joinArrayWithOr(mapArray($tera.project.TrialWizard.secondary, "name")) }}
			{{ selectRandom([" assessed by ", " analysed by ", "evaluated by "]) }}
			{{
				joinArrayWithOr(mapArray($tera.project.TrialWizard.secondary, "assessed"))
			}}
			{{
				selectRandom([
					"at the following time points: ",
					"at the following periods in the trial: ",
					"at ",
					"at the time points: "
				])
			}}
			{{
				joinArrayWithAnd(mapArray($tera.project.TrialWizard.secondary, "time"))
			}}.
		</p>
		<p>
			{{
				selectRandom([
					"Adverse events of particular interest are ",
					"The following Adverse events will be recorded ",
					"Adverse events of interest are ",
					"Adverse events to will be recorded are "
				])
			}}
			{{ joinArrayWithOr(mapArray($tera.project.TrialWizard.adverse, "name")) }}
			{{
				selectRandom([
					". Adverse events will be assessed by ",
					". The assessment of adverse events will be done by ",
					". The assessment of adverse events will be completed by ",
					". Adverse events will be completed by "
				])
			}}
			{{
				joinArrayWithOr(mapArray($tera.project.TrialWizard.adverse, "assessed"))
			}}
			{{
				selectRandom([
					"at the following time points: ",
					"at the following periods in the trial: ",
					"at the following points: ",
					"at the following points in the trial: "
				])
			}}
			{{ joinArrayWithAnd(mapArray($tera.project.TrialWizard.adverse, "time")) }}.
		</p>
		<p>
			{{
				selectRandom([
					"The clinical relevance of the chosen efficacy and harm outcomes is supported by ",
					"The importance, efficacy and associated harms of the outcomes is supported by ",
					"The significance, effectiveness, and potential adverse outcomes of outcomes are supported by ",
					"The significance, efficacy, and harms of the outcomes will be supported by "
				])
			}}
			{{ $tera.project.TrialWizard.clinicalRelevance }}.
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputOutcomes",
	mixins: [OutputMixin]
};
</script>
